/**
 * Хто горить.
 *
 * "Вогонь повинен вбивати та запалювати людей тварин." Fire ate walls and
 * roofs and left everybody standing in it untouched; you could walk through
 * a burning house and come out the other side.
 *
 * A book of who is alight rather than a field on the orc and another on the
 * beast and a third on the player: three lists of bodies with three different
 * shapes, all of which burn identically. Keyed by a name the caller makes up
 * - "orc:7", "beast:7", "player" - because orcs and beasts number themselves
 * from one apiece and their ids collide.
 *
 * Nothing here removes anybody: a body that dies simply stops being asked
 * about, and its entry burns out on its own a few seconds later.
 *
 * Pure: names, timers and numbers. It never touches a world or an entity.
 */

/** How long a body stays alight after it leaves the flames. */
export const SCORCH_SECONDS = 5;

/** What one bite of burning takes off. */
export const SCORCH_DAMAGE = 2;

/**
 * Seconds between bites.
 *
 * A second, which with `SCORCH_SECONDS` makes five bites and ten points for
 * anything that walks into a fire and out again - survivable by a person,
 * fatal to a курка, which is about right. Standing in it keeps refreshing
 * the timer, so standing in it kills.
 */
export const SCORCH_GAP = 1;

interface Alight {
  /** Seconds of burning left. */
  left: number;
  /** Seconds until the next bite. */
  next: number;
}

export class Burning {
  private readonly lit = new Map<string, Alight>();

  get size(): number {
    return this.lit.size;
  }

  isAlight(who: string): boolean {
    return this.lit.has(who);
  }

  /** Every body alight, for drawing flames on it. */
  alight(): string[] {
    return [...this.lit.keys()];
  }

  /**
   * Set somebody alight, or keep them that way.
   *
   * @returns whether they were not already burning, so the caller can make a
   * noise the once rather than every tick they stand in the fire.
   */
  light(who: string): boolean {
    const already = this.lit.get(who);
    if (already !== undefined) {
      already.left = SCORCH_SECONDS;
      return false;
    }
    // The first bite lands at once. Stepping into a fire has to hurt on the
    // frame you step in, or the flames read as scenery.
    this.lit.set(who, { left: SCORCH_SECONDS, next: 0 });
    return true;
  }

  /** Put somebody out - a swim, or a death. */
  out(who: string): void {
    this.lit.delete(who);
  }

  /** Burn for a while. @returns who takes `SCORCH_DAMAGE` this step. */
  step(dt: number): string[] {
    const bitten: string[] = [];
    for (const [who, alight] of [...this.lit]) {
      alight.left -= dt;
      alight.next -= dt;
      if (alight.next <= 0) {
        alight.next = SCORCH_GAP;
        bitten.push(who);
      }
      if (alight.left <= 0) this.lit.delete(who);
    }
    return bitten;
  }
}
